import Button from "../layout/Button"


export default function Quote({
  text,
  subtext = null,
}: {
  text: string | undefined;
  subtext: string | null | undefined;
}) {
  return (
    <div className="bg-dark-blue py-12 sm:py-20 relative">
      <div className="mx-auto max-w-8xl px-6 lg:px-8 grid grid-cols-1 justify-center gap-y-6 text-center">
        
        <h1 className="text-6xl font-bold text-white">"{text}"</h1>
        <h1 className="text-4xl font-medium text-white">{subtext}</h1>

      </div>
    </div>
  )
}
